"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryClient = void 0;
const BaseClient_1 = require("../BaseClient");
/**
 * @deprecated
 * @see AuditClient
 */
class HistoryClient extends BaseClient_1.BaseClient {
    constructor(entity, baseUrl, tokenProvider) {
        super(baseUrl, tokenProvider);
        this.entity = entity;
    }
    async get(request) {
        const response = await this.axiosInstance({
            method: 'GET',
            url: '/api/v1/history/get',
            params: {
                id: request.id,
                entity: this.entity,
                limit: request.limit,
                offset: request.offset,
            },
        });
        return response.data;
    }
}
exports.HistoryClient = HistoryClient;
